export default "__VITE_ASSET__D3n84gvj__"